import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=48ae5556&scoped=true&lang=pug&"
import script from "./Logs.vue?vue&type=script&lang=js&"
export * from "./Logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae5556",
  null
  
)

export default component.exports